const PLANS = {
    COLLECTION: {
        url: '/organization/:organizationId/clientSubscriptionPlans'
    },
    COLLECTION_PARENT_PLANS: {
        url: '/organization/:organizationId/providerSubscriptionPlans',
        queryKey: 'getParentPlans'
    },
    COLLECTION_PLAN_ALLOWED_CLIENTS: {
        url: '/organization/:organizationId/clientSubscriptionPlans/:planId/allowedClients',
        queryKey: 'getAllowedClients'
    },
    PLAN_ALLOWED_CLIENT_DETAILS: {
        url: '/organization/:organizationId/clientSubscriptionPlans/:planId/allowedClients/:allowedClientId'
    },
    DETAILS: {
        url: '/organization/:organizationId/clientSubscriptionPlans/:planId',
        queryKey: 'getPlan'
    },
    UPDATE: {
        url: '/organization/:organizationId/plan/:planId'
    }
};

export { PLANS };